import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'appName',
  initialState: null as string | null,
  reducers: {
    setAppName(state, action: PayloadAction<string>) {
      return action.payload || null;
    },
  },
});

export const { setAppName } = slice.actions;

export default slice.reducer;
